import { Directive, TemplateRef, Input, ElementRef } from '@angular/core';
import { GasMathHelper } from '@cikrf/gas-utils/helpers';

/**
 * @description Директива для создания секций внутри аккордиона
 * @param label - заголовок секции
 * @param labelContext - контекст заголовка
 * @param name - уникальное имя секции
 * @example <ng-template label="Имя секции" labelContext="Контекст" name="A">Контент</ng-template>
 */
@Directive({
  selector: '[gasAccordionSection]',
})
export class GasAccordionSectionDirective {
  /** Заголовок секции */
  @Input()
  public label: string | TemplateRef<ElementRef>;

  /** контекст заголовка */
  @Input()
  public labelContext: string;

  /** уникальное имя секции */
  @Input()
  public name = GasMathHelper.getUniqueId();

  /** указывает, что секция является частью аккордиона */
  public type = 'Accordion-item';

  constructor(
    /** public для поддержки лайтинга */
    public templateRef: TemplateRef<ElementRef>,
  ) {}
}
